import React from "react";
import { Carousel, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getPath } from "../utils/constants";

// Hero slide data
const heroData = [
  {
    key: "book-kembar",
    isComingSoon: false,
    image: "/assets/images/banner-kembar.jpg",
    imagelet: "/assets/images/bannerlet-kembar.png",
    buttonPath: "https://childreams.co.id/",
    color: "#ffe1fd",
  },
  {
    key: "book-reja",
    isComingSoon: true,
    image: "/assets/images/banner-reja.jpg",
    imagelet: "/assets/images/bannerlet-reja.png",
    buttonPath: getPath("jejakRejakids"),
    color: "#fdffb1",
  },
  {
    key: "book-bira",
    isComingSoon: true,
    image: "/assets/images/banner-bira.jpg",
    imagelet: "/assets/images/bannerlet-bira.png",
    buttonPath: getPath("bira"),
    color: "#f9dfe8",
  },
  {
    key: "book-cimi",
    isComingSoon: true,
    image: "/assets/images/banner-cimi.jpg",
    imagelet: "/assets/images/bannerlet-cimi.png",
    buttonPath: getPath("adventureOfCimiCimo"),
    color: "#ffffff",
  },
  {
    key: "book-gani",
    isComingSoon: true,
    image: "/assets/images/banner-gani.jpg",
    imagelet: "/assets/images/bannerlet-gani.png",
    buttonPath: getPath("gani"),
    color: "#e1f8f0",
  },
];

const getTextShadow = (color) => `
  -3px -3px 0 ${color},
  3px -3px 0 ${color},
  -3px 3px 0 ${color},
  3px 3px 0 ${color},
  0 -3px 0 ${color},
  0 3px 0 ${color},
  -3px 0 0 ${color},
  3px 0 0 ${color},
  -2px -2px 0 ${color},
  2px -2px 0 ${color},
  -2px 2px 0 ${color},
  2px 2px 0 ${color},
  -1px -1px 0 ${color},
  1px -1px 0 ${color},
  -1px 1px 0 ${color},
  1px 1px 0 ${color}
`;

const HeroBanner = () => {
  const { t } = useTranslation();
  const timeInterval = 5000;

  return (
    <section className="hero-banner py-0">
      <div className="d-none d-md-block">
        <Carousel fade interval={timeInterval} className="banner-area-desktop">
          {heroData.map((item, index) => (
            <Carousel.Item key={item.key}>
              <img className="w-100 img-fluid banner-image" src={item.image} alt={t(`${item.key}.title`)} />

              <Container>
                <div
                  className="banner-text"
                  style={{
                    position: "absolute",
                    top: "50%",
                    transform: "translateY(-50%)",
                    textShadow: getTextShadow(item.color),
                  }}
                >
                  {item.isComingSoon ? (
                    <h2>Coming Soon</h2>
                  ) : (
                    <React.Fragment>
                      <h2>{t(`${item.key}.title`)}</h2>
                      <p>{t(`${item.key}.desc`)}</p>
                      {/* <button className="btn btn-eclipse">{t("cta-see-product")}</button> */}
                      <Link to={item.buttonPath} className="btn btn-eclipse">
                        {t("cta-see-product")}
                      </Link>
                    </React.Fragment>
                  )}
                </div>
              </Container>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>

      <div className="d-block d-md-none">
        <Carousel fade interval={timeInterval} className="banner-area-mobile">
          {heroData.map((item, index) => (
            <Carousel.Item key={index}>
              <img className="w-100 img-fluid banner-image" src={item.imagelet} alt={t(`${item.key}.title`)} />
              <Container>
                <div className="banner-text">
                  {item.isComingSoon ? (
                    <h2>Coming Soon</h2>
                  ) : (
                    <React.Fragment>
                      <h2>{t(`${item.key}.title`)}</h2>
                      <p>{t(`${item.key}.desc`)}</p>
                      <Link to={item.buttonPath} className="btn btn-eclipse">
                        {t("cta-see-product")}
                      </Link>
                    </React.Fragment>
                  )}
                </div>
              </Container>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </section>
  );
};

export default HeroBanner;
